module.exports = __webpack_public_path__ + "static/Lolchess-27ddb1b46c4cef037fcfe74919be2af0.png";